import { ContactForm } from "../sections/Contact";

const Contact = () => {
  return (
    <div className="min-h-screen pt-20">
      <section className="bg-covers py-20 px-4 text-center">
        <h1 className="text-4xl font-bold mb-2 cover-primary-text">
          Contact Us
        </h1>
        <p className="text-lg max-w-2xl mx-auto cover-secondary-text">
          We are here to help you. Please use the form below to get in touch
          with us.
          <br />
          We will get back to you as soon as possible.
        </p>
      </section>

      <section className="py-16 px-6">
        <ContactForm />
      </section>
    </div>
  );
};

export default Contact;
